// Product Sales Dashboard (the embedded Superset unit-sales board) — the screen's strings in the portal's four
// languages (2026-10-21).
const en = {
  loading: 'Loading...',
  notAuthorized: 'You are not authorized to view this page.',
};
const ko = {
  loading: '불러오는 중...',
  notAuthorized: '이 페이지를 볼 권한이 없습니다.',
};
const vi = {
  loading: 'Đang tải...',
  notAuthorized: 'Bạn không có quyền xem trang này.',
};
const zh = {
  loading: '加载中...',
  notAuthorized: '您无权查看此页面。',
};

const dictionary = { ns: 'xUnitSales', en, ko, vi, zh };

export default dictionary;
